<script setup lang='ts'>
import type { BrandResponse } from '~~/src/server/modules/car/types'
import type { BrandDict } from '~~/src/logic/search/brand'
import { LogicSearchBrand } from '~~/src/logic/search/brand'

const props = withDefaults(defineProps<{
  brands: BrandResponse[]
}>(), {
  brands: () => [],
})
const emits = defineEmits({
  select: (_data: BrandResponse) => true,
})
const searchKey = ref('')
const {
  dictData,
  search,
  initHandler,
} = LogicSearchBrand()
const searchFocus = ref(false)
const searchResult = ref<BrandDict[]>([])
const history = useLocalStorage('car-brand-search-history', [] as BrandDict[])

function searchHandler() {
  if (!searchKey.value) {
    searchResult.value = []
    return
  }

  const result = search(searchKey.value?.toLocaleLowerCase?.()) || []
  searchResult.value = result
  // console.table(result)
}
function selectHandler(data: BrandDict) {
  const item = props.brands.find(v => v.id === data.brandId)
  if (!item)
    return

  const index = history.value.findIndex(v => v.brandId === data.brandId)
  index > -1 && history.value.splice(index, 1)
  history.value.unshift(data)
  history.value.length > 5 && history.value.pop()

  item && emits('select', item)
}
let timer: NodeJS.Timeout
const blurHandler = () => {
  timer && clearTimeout(timer)
  timer = setTimeout(() => searchFocus.value = false, 200)
}
let stops = [
  watchDebounced(searchKey, searchHandler, { debounce: 0 }),
  watch(() => props.brands, initHandler, { immediate: true }),
]
onBeforeUnmount(() => {
  stops.forEach(stop => stop())
  timer && clearTimeout(timer)
  stops = null!
})
</script>

<template>
  <div>
    <div class="relative">
      <input
        v-model="searchKey" type="text"
        class="w-full h-9 border-1 border-gray-200 rounded-md px-2 focus-border-2 focus-border-blue-5"
        placeholder="请输入品牌/首字母"
        @focus="searchFocus = true"
        @blur="blurHandler"
      >
      <div v-show="searchFocus && (searchResult.length || history.length)" class="absolute left-0 right-0 top-10 bg-white py-3 rounded-md z-1 border-1 border-gray-2 shadow-md">
        <n-scrollbar class="max-h-50 px-3 text-4" trigger="none">
          <template v-if="searchKey">
            <div v-show="!searchResult.length" class="text-center p-3 text-3 text-slate-4">
              暂无相关数据
            </div>
            <div
              v-for="v in searchResult" :key="v.brandId" class="block p-2 rounded-md md:hover:bg-gray-100 md:hover:text-blue-5 cursor-pointer"
              @click="selectHandler(v)"
            >
              {{ v.brandName }}
            </div>
          </template>
          <template v-else>
            <client-only>
              <h4 class="text-3 text-slate-5">
                搜索历史
              </h4>
              <div
                v-for="v in history" :key="v.brandId" class="block p-2 rounded-md md:hover:bg-gray-100 md:hover:text-blue-5 cursor-pointer"
                @click="selectHandler(v)"
              >
                {{ v.brandName }}
              </div>
            </client-only>
          </template>
        </n-scrollbar>
        <div class="absolute top-0 right-0 p-1 cursor-pointer" @click="searchFocus = false">
          <i class="i-carbon-close text-5 " />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang='scss' scoped>

</style>
